module.exports = {
    projectName: "wm-dmaarchitekten-tibi-2022",
    operatorEmail: "__OPERATOR_EMAIL_",

    apiBase:"https://dmarchitekten.de/api/",
    frontendBase:"https://dmarchitekten.de/",

    publicToken: "TMC8cBq0bsL4WbAkqMe3787Aif3MjYPC",
    ssrToken: "qD3MD6xY4ht3CPfSa22dHk4XaS7p0nTb",

    ssrValidatePath: function (path) {
        // TODO validate if path ssr rendering is ok, -1 = NOTFOUND, 0 = NO SSR, 1 = SSR
        // pe. use context.readCollection("product", {filter: {path: path}}) ... to validate dynamic urls

        return path.match(/^\/(home|service)\/?$/)
    },
}
